import { DataSource, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCollectionsExpand extends Layout {
    layoutImageTable: Layout;
    panelTotalAmountBilled: Panel;
    panelTotalAmountPaid: Panel;
    panelTotalOutstandingBalance: Panel;
    panelTotalPaymentAdjustments: Panel;
    sourceOpenItemCollections: DataSource;
    tabImages: Tab;
    tabInvoiceActivity: Tab;
    tableInvoiceActivity: Table;
    tabsetCollectionsExpand: Tabset;
    textboxTotalAmountBilled: Textbox;
    textboxTotalAmountPaid: Textbox;
    textboxTotalOutstandingBalance: Textbox;
    textboxTotalPaymentAdjustments: Textbox;
}
